
// export const API_URL = "https://szdigitalcardweb-dev.metazh.cn/cardweb";
export const API_URL = "https://szdigitalcardweb.metazh.cn/cardweb";
export const STATIC_RES_URL = "https://dmresource.fuyuncc.com/lawerWeb"; // 服务器地址
export const staticUrl = "https://dmresource.fuyuncc.com/digitalCard";
export const H5_URL = "https://yyxcx.metazh.cn";
// https://szdigitalcardweb-pre.metazh.cn/